var CreateCustomerManufacturerCtrl = function ($scope, previousState, customerModelService, $log, SettingsConstants, $state, createCustomerLoader, apiService, $q, VehicleService, errorRouterService, errorScreenService, ERR) {
    var vm = this;

    // this variables stores all listeners to the http error to have
    // possibility to unsubscribe when scope destroy event calls
    var httpErrorsListeners = [];
    httpErrorsListeners.push(errorRouterService.subscribe(function (err) {
        if (err && err.status == 500) {
            invokeGetItemError();
            return $q.when(true);
        }
    }, { resourceName: 'getManufacturers', status: '*' }));

    //trigger error screen
    function invokeGetItemError() {
        errorScreenService.error(true, ERR.CAN_NOT_GET_AVALIABLE_MODEL, {
            noFullScreen: true,
            template: 'template/errorscreens/can-not-get-avaliable-item',
            errorType: ERR.CAN_NOT_GET_AVALIABLE_MODEL,
            vinDecode: $scope.$parent.vinDecodeOptions
        });
    }

    //setVehicleModel
    //
    //@param {object} selected model object
    //
    //@description
    //Method calls when user select model
    vm.setManufacturer = function (manufacturer) {
        customerModelService.setCurrentVehicle(VehicleService.createNewVehicle({ make: manufacturer }));
        $scope.ctrl.goToState($scope.ctrl.currentStateIndex + 1, $scope.vehicleCreationData.transmissions);
    };
    //getManufacturers
    //
    //@return {Object} promise with resolved data or rejected error message
    //
    //@description
    //get backend request for the list of the possible manufactirers
    function getManufacturers() {
        var deferred = $q.defer();
        apiService.getCatalog().then(function (catalog) {
            return catalog.getManufacturers();
        }).then(function (result) {
            deferred.resolve(result);
        }).catch(function (err) {
            deferred.reject(err);
        });
        return deferred.promise;
    }
    //
    function init() {
        createCustomerLoader.addPromise(
            getManufacturers()
                .then(function (items) {
                    if (!items || items.length === 0) {
                        invokeGetItemError();
                        $scope.vehicleCreationData.manufacturers = [];
                        return;
                    }

                    if (window.appSettings.featureJeepWagoneerEnabled) {
                        items.forEach((o)=>{
                            if (o.id === 111) o.customLabel = "JEEP/WAGONEER";
                        })
                    }

                    //order
                    var result = _.orderBy(items, 'name', 'asc');
                    //get the set of the main manufacturers
                    var filtered = result.filter(function (el) {
                        return el.main;
                    });
                    //select the first main manufacturer
                    var mainManufacturer = filtered[0];
                    //exclude all manufacturers with main property set to true
                    filtered = result.filter(function (el) {
                        return !el.main;
                    });
                    //set the main manufacturer as the first element of the manufacrurers collection
                    filtered.unshift(mainManufacturer);
                    //
                    $scope.vehicleCreationData.manufacturers = filtered;
                })
                .catch(function (err) {
                    $log.error('Something went wrong', err);
                }));
    };
    //unsubscribe all http exception listeners
    $scope.$on('$destroy', function () {
        httpErrorsListeners.forEach(function (id) {
            errorRouterService.unsubscribe(id);
        });
    });
    //start
    init();
};
CreateCustomerManufacturerCtrl.$inject = ['$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'createCustomerLoader', 'apiService', '$q', 'VehicleService', 'errorRouterService', 'errorScreenService', 'errors'];

module.exports = CreateCustomerManufacturerCtrl;
